import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { withRouter } from 'react-router-dom';
import {
    GridList,
    GridTile,
} from 'material-ui/GridList';

import {
    projetoService,
    eventoService,
    Utils,
} from '../../services';
import InscricaoDetalhes from './InscricaoDetalhes';

class InscricaoStepTermo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            termoInscricao: '',
            habilitado: true,
            base64Arquivo: '',
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        this.form = await projetoService.projetoForm();

        const codigoEvento = this.props.detalhesInscricao.evento;
        if (codigoEvento) {
            try {
                const evento = await eventoService.getEvento(codigoEvento);
                this.setState({
                    termoInscricao: evento.TERMOINSCRICAO,
                    base64Arquivo: await Utils.getBase64(this.props.detalhesInscricao.arquivo),
                });
            } catch (error) {
                Utils.showToast(error.message);
            }
        }
        Utils.showLoading(false);
    }

    async onAceitarTermo() {
        await this.props.onAceitarTermo(this.form);
    }

    async cancelar() {
        window.location.href = '/inscricao';
    }

    render() {
        const { detalhesInscricao } = this.props;

        return (
            <div>
                <InscricaoDetalhes detalhesInscricao={detalhesInscricao} />

                <div className="padding-content">
                    <TextField
                        floatingLabelText="Termo de Inscrição e geração de boleto"
                        value={this.state.termoInscricao}
                        fullWidth
                        required
                        multiLine
                        readOnly
                        rows={7}
                    />
                    <br />
                    <Checkbox
                        label="Li e entendi os próximos passos para concluir a inscrição"
                        onCheck={e => this.setState({ habilitado: !e.target.checked })}
                    />
                    <br />
                    <GridList cols={2} cellHeight="auto">
                        <GridTile cols={1} style={{ textAlign: 'center' }}>
                            <RaisedButton
                                style={{ margin: 4 }}
                                label="Cadastrar projeto"
                                primary
                                disabled={this.state.habilitado}
                                onClick={() => this.onAceitarTermo()}
                            />
                        </GridTile>
                        <GridTile cols={1} style={{ textAlign: 'center' }}>
                            <RaisedButton
                                style={{ margin: 4 }}
                                label="Cancelar tudo"
                                onClick={() => this.cancelar()}
                            />
                        </GridTile>
                    </GridList>
                    <br />
                    <br />
                    {
                        this.state.base64Arquivo &&
                        <iframe
                            style={{ marginTop: 16 }}
                            src={this.state.base64Arquivo}
                            height={842}
                            width="100%"
                            title="PDF inscrição"
                            frameBorder="0"
                        />
                    }
                </div>
            </div>
        );
    }
}

InscricaoStepTermo.propTypes = {
    onAceitarTermo: PropTypes.func.isRequired,
    detalhesInscricao: PropTypes.shape({
        evento: PropTypes.number.isRequired,
        eixo: PropTypes.number.isRequired,
        area: PropTypes.number.isRequired,
        subevento: PropTypes.number.isRequired,
        categoria: PropTypes.number.isRequired,
        titulo: PropTypes.string.isRequired,
        instituicao: PropTypes.string.isRequired,
        tipo: PropTypes.number.isRequired,
        arquivo: PropTypes.oneOfType([
            PropTypes.instanceOf(Blob),
            PropTypes.instanceOf(File),
        ]),
        autores: PropTypes.array.isRequired,
    }).isRequired,
};

export default withRouter(InscricaoStepTermo);
